import { useCustomerInvitationConfigSuspense } from "@boundless/bl-api-client/customer/services"
import { TriangleAlertIcon } from "lucide-react"

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"

export function OutOfReferralsAlert() {
  const { data: config, isSuccess } = useCustomerInvitationConfigSuspense()

  const hasReferralsLeft = isSuccess && config.referralsLeft > 0

  return hasReferralsLeft ? null : (
    <Alert variant="warning">
      <TriangleAlertIcon />
      <AlertTitle>You have reached the limit of pending referrals.</AlertTitle>
      <AlertDescription>
        Please wait for some to be processed before sending more.
      </AlertDescription>
    </Alert>
  )
}
